module.exports = __webpack_public_path__ + "img/cef_logo.08d9e0a0.png";